/**
 * Shuffles items in an array.
 * @param {Array} array An array with items.
 * @return A shuffled version of the array.
 */
export function shuffled(array) {
  const result = [...array];
  for (let i = result.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    const temp = result[i];
    result[i] = result[j];
    result[j] = temp;
  }
  return result;
}

/**
 * Sorty the array by the specified property
 * @param {string} property
 * @param {Array} array
 * @return A sorted version of the array.
 */
export function sortByProp(property, array) {
  const result = [...array];
  result.sort((a, b) => {
    const valA = a[property]
    const valB = b[property]
    if (valA === valB) {
      return 0
    }
    if (valA == null) {
      return 1;
    }
    return valA > valB ? 1 : -1
  });
  return result;
}

/**
 * Will parse a comma separated list and return an array
 * of the integer values.
 * @param str A comma separated list of integers
 * @return {Array}
 */
export function parseIntegerList(str) {
  if (!str) {
    return [];
  }
  return str.split(/,\s*/).map(val => Number.parseInt(val));
}
